import { ArrowTopRightOnSquareIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { map } from 'lodash'
import { MessageDescriptor, useIntl } from 'react-intl'

import WorkgridIcon from '@/components/images/WorkgridIcon'
import Modal from '@/components/Modal'
import Button from '@/components/TailwindUI/Button'
import Image from '@/components/TailwindUI/Image'
import defaultMessages from '@/messages'

import book from './images/book.png'
import chip from './images/chip.png'
import graduate from './images/graduate.png'
import sendDoc from './images/sendDoc.png'
import settings from './images/settings.png'
import speedometer from './images/speedometer.png'
import study from './images/study.png'
import support from './images/support.png'
import messages from './messages'

type NewHereModalProps = {
  isOpen: boolean
  onClose: () => void
}

const cards = [
  {
    title: messages.gettingStartedGuide,
    subtitle: messages.gettingStartedSubTitle,
    icon: speedometer,
    href: 'https://help.workgrid.com/s/getting-started-champion-guide'
  },
  {
    title: messages.articles,
    subtitle: messages.articlesSubTitle,
    icon: book,
    href: 'https://help.workgrid.com/s/articles'
  },
  {
    title: messages.integrations,
    subtitle: messages.integrationsSubTitle,
    icon: chip,
    href: 'https://help.workgrid.com/s/integrations'
  },
  {
    title: messages.releaseNotes,
    subtitle: messages.releaseNotesSubTitle,
    icon: sendDoc,
    href: 'https://help.workgrid.com/s/article/Release-Notes'
  },
  {
    title: messages.tutorials,
    subtitle: messages.tutorialsSubTitle,
    icon: graduate,
    href: 'https://help.workgrid.com/s/tutorials'
  },
  {
    title: messages.resourceHub,
    subtitle: messages.resourceHubSubTitle,
    icon: study,
    href: 'https://www.workgrid.com/resources/resource-hub/'
  },
  {
    title: messages.developers,
    subtitle: messages.developersSubTitle,
    icon: settings,
    href: 'https://help.workgrid.com/s/articles?tabset-9033e=b6fea'
  },
  {
    title: messages.askSupport,
    subtitle: messages.askSupportSubTitle,
    icon: support,
    href: 'https://help.workgrid.com/s/contactsupport'
  }
]
const NewHereModal = ({ isOpen, onClose }: NewHereModalProps) => {
  const intl = useIntl()
  return (
    <Modal isOpen={isOpen} onClose={onClose} className="max-w-7xl">
      <div className="flex-col p-4">
        <Button color="transparent" className="float-right" onClick={onClose}>
          <XMarkIcon className="h-6 w-6 text-zinc-500" />
        </Button>
        <div key="header" className="flex h-12 flex-nowrap items-center gap-x-2 text-4xl">
          <WorkgridIcon className="h-10 w-10 text-brand-500" />
          <h1 className="text-zinc-800">{intl.formatMessage(defaultMessages.workgrid)}</h1>
          <h1 className="text-brand-500">{intl.formatMessage(messages.help)}</h1>
        </div>
      </div>
      <div className="grid w-full grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {map(cards, card => (
          <Card {...card} />
        ))}
      </div>
    </Modal>
  )
}

export default NewHereModal

const Card = ({
  title,
  subtitle,
  icon,
  href
}: {
  title: MessageDescriptor
  subtitle: MessageDescriptor
  icon: string
  href: string
}) => {
  const intl = useIntl()
  return (
    <div className="group flex min-h-[200px] flex-col justify-between rounded-lg p-4 shadow-md hover:ring-2 hover:ring-inset hover:ring-brand-600">
      <a href={href} target="_blank" rel="noreferrer" className="flex flex-grow flex-col">
        <div className="flex-grow text-start">
          <div className="flex w-full justify-between">
            <h2 className="text-xl font-bold text-brand-500 group-hover:underline">{intl.formatMessage(title)}</h2>
            <ArrowTopRightOnSquareIcon className="h-6 w-6 text-brand-300" />
          </div>
          <p className="mt-3 text-base text-zinc-500">{intl.formatMessage(subtitle)}</p>
        </div>
        <div className="mt-auto flex w-full justify-center">
          <Image src={icon} alt={intl.formatMessage(title)} className="mx-auto block h-24 w-24" />
        </div>
      </a>
    </div>
  )
}
